import React from "react";

export default function Footer() {
  return (
    <p class="signature">
      {" "}
      <a
        href="https://github.com/akgoreandrews/react-weather-app"
        target="blank"
      >
        {" "}
        Open-source code
      </a>
       {" "}by: Anne-Katherine Treur
    </p>
  );
}